import TreeViewContainer from "../../components/bonusUi/treeView";

const Tree = () => {
  return <TreeViewContainer />;
};

export default Tree;
